import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AutenticacaoService } from '../services/autenticacao.service';
import { SharedService } from '../services/shared.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AutenticacaoService,
    private sharedService: SharedService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const beneficiario = localStorage.getItem("currentUser");
    if (beneficiario === null) {
      this.router.navigate(['/login'])
      return false;
    }

    this.sharedService.beneficiario = JSON.parse(beneficiario);
    this.sharedService.beneficiarioSelecionado = JSON.parse(beneficiario);

    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      return true;
    }

    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
